import React from 'react'
import { withAuthorization } from 'components/common/AuthorizedUser'

import Gigs from "./Gigs"
import { LiveGigsProvider } from './Gigs'
import { SavedGigsProvider } from './Gigs'

const GetNext = () => {
  return(
    <LiveGigsProvider>
      <SavedGigsProvider>
          <Gigs />
      </SavedGigsProvider>
    </LiveGigsProvider> 
  )
}

const condition = authorizedUser => !!authorizedUser;
export default withAuthorization(condition)(GetNext)
